<template>
  <form class="SearchBox form-inline">
    <input class="form-control mr-sm-2" @input="onChange" type="text" :placeholder="`Search ${name}`">
    {{ search }}
    <button v-if="showButton" class="btn btn-primary" type="submit">Search</button>
  </form>
</template>

<script>
export default {
  name: 'SearchBox',
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  mounted () {},
  data: () => ({
    search: ''
  }),
  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss">
    .SearchBox {
      margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SearchBox/searchbox.vue